/**
 * 連絡事項変更時: 登録前に通知の確認モーダルを表示する（はい=保存+通知 / いいえ=保存のみ / X=キャンセル）。
 *
 * @param {{
 *   formId: string,
 *   notesFieldId: string,
 *   notifyFieldId: string,
 *   modalId: string,
 *   yesButtonId: string,
 *   noButtonId: string,
 *   skipWhen?: { rootId: string, dataAttribute: string, skipValue: string },
 * }} options
 * @returns {void}
 */
export function bindOrderNotesNotifyConfirm(options) {
    const form = document.getElementById(options.formId);
    const notesField = document.getElementById(options.notesFieldId);
    const notifyField = document.getElementById(options.notifyFieldId);
    const modalElement = document.getElementById(options.modalId);

    if (options.skipWhen !== undefined) {
        const skipRoot = document.getElementById(options.skipWhen.rootId);
        if (
            skipRoot !== null &&
            skipRoot.dataset[options.skipWhen.dataAttribute] === options.skipWhen.skipValue
        ) {
            return;
        }
    }

    if (
        !(form instanceof HTMLFormElement) ||
        !(notesField instanceof HTMLTextAreaElement) ||
        !(notifyField instanceof HTMLInputElement) ||
        modalElement === null
    ) {
        return;
    }

    const initialNotes = notesField.dataset.initialNotes ?? '';

    /**
     * @param {string|null|undefined} value
     * @returns {string|null}
     */
    function normalizeNotesValueForCompare(value) {
        const text = value == null ? '' : String(value);
        return text === '' ? null : text;
    }

    /**
     * @param {string|null|undefined} leftNotes
     * @param {string|null|undefined} rightNotes
     * @returns {boolean}
     */
    function orderNotesValuesEqual(leftNotes, rightNotes) {
        return normalizeNotesValueForCompare(leftNotes) === normalizeNotesValueForCompare(rightNotes);
    }

    form.addEventListener('submit', (event) => {
        if (form.dataset.notesNotifyResolved === '1') {
            form.dataset.notesNotifyResolved = '0';
            return;
        }

        const submitter = event.submitter;
        if (submitter instanceof HTMLElement) {
            const formAction = submitter.getAttribute('formaction');
            if (formAction !== null && formAction !== '') {
                return;
            }
        }

        if (orderNotesValuesEqual(initialNotes, notesField.value)) {
            notifyField.value = '';
            return;
        }

        event.preventDefault();

        const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
        const yesButton = document.getElementById(options.yesButtonId);
        const noButton = document.getElementById(options.noButtonId);
        let resolved = false;

        /**
         * @returns {void}
         */
        function cleanupListeners() {
            if (yesButton instanceof HTMLButtonElement) {
                yesButton.removeEventListener('click', onYesClick);
            }
            if (noButton instanceof HTMLButtonElement) {
                noButton.removeEventListener('click', onNoClick);
            }
            modalElement.removeEventListener('hidden.bs.modal', onModalHidden);
        }

        /**
         * @param {'0'|'1'} notifyValue
         * @returns {void}
         */
        function submitWithNotifyChoice(notifyValue) {
            if (resolved) {
                return;
            }
            resolved = true;
            cleanupListeners();
            notifyField.value = notifyValue;
            form.dataset.notesNotifyResolved = '1';
            modal.hide();
            if (submitter instanceof HTMLElement) {
                form.requestSubmit(submitter);
                return;
            }
            form.requestSubmit();
        }

        /**
         * @returns {void}
         */
        function onYesClick() {
            submitWithNotifyChoice('1');
        }

        /**
         * @returns {void}
         */
        function onNoClick() {
            submitWithNotifyChoice('0');
        }

        /**
         * @returns {void}
         */
        function onModalHidden() {
            cleanupListeners();
        }

        if (yesButton instanceof HTMLButtonElement) {
            yesButton.addEventListener('click', onYesClick);
        }
        if (noButton instanceof HTMLButtonElement) {
            noButton.addEventListener('click', onNoClick);
        }
        modalElement.addEventListener('hidden.bs.modal', onModalHidden);
        modal.show();
    });
}
